import { formatPeriod } from '../utils';

const FORMALITY_HUMAN = {
  prenom: 'Tutoiement par prénom',
  nom: 'Vouvoiement par nom',
  neutre: 'Salutation neutre',
};

/**
 * Page de garde du rapport mensuel — première section visible de l'onglet
 * "Lettre & synthèse". Reprend la convention de référence du brief :
 * "Édition MM/AAAA · Référence AAAA-MM-CodeOfficine".
 */
export default function ReportCover({ report }) {
  const formatted_period = formatPeriod(report.period);
  const formality_label = FORMALITY_HUMAN[report.formality_preference] || FORMALITY_HUMAN.nom;

  return (
    <header className="border-b border-cabinet-border pb-10" data-testid="report-cover">
      <div className="flex items-start justify-between mb-12 gap-6 flex-wrap">
        <div>
          <div className="font-playfair text-[12px] text-cabinet-bordeaux tracking-[0.3em] uppercase">
            Cabinet Benchory
          </div>
          <div className="text-[10px] text-cabinet-ink-secondary uppercase tracking-[0.22em] mt-1">
            Pilotage officinal · Conseil stratégique
          </div>
        </div>
        <div className="text-right text-[10px] text-cabinet-ink-secondary uppercase tracking-[0.2em] leading-relaxed">
          <div>Édition {formatted_period}</div>
          <div className="mt-1 text-cabinet-ink-soft">
            Référence {report.period}{report.code_officine ? ` · ${report.code_officine}` : ''}
          </div>
        </div>
      </div>

      <h1 className="font-playfair text-[28px] text-cabinet-ink leading-tight mb-3" data-testid="report-cover-title">
        Rapport mensuel de pilotage
      </h1>
      <p className="font-playfair italic text-[16px] text-cabinet-ink-secondary mb-8">
        {report.establishment_name || 'Officine'}
      </p>

      <div className="flex items-center gap-x-6 gap-y-2 text-[10px] text-cabinet-ink-secondary uppercase tracking-[0.18em] flex-wrap">
        <span>Pilotage · {formality_label}</span>
        <span className="text-cabinet-gold-soft" aria-hidden>·</span>
        <span>Période analysée · {formatted_period}</span>
        {report.generated_at && (
          <>
            <span className="text-cabinet-gold-soft" aria-hidden>·</span>
            <span>
              Édité le {new Date(report.generated_at).toLocaleDateString('fr-FR', {
                day: '2-digit', month: 'long', year: 'numeric',
              })}
            </span>
          </>
        )}
      </div>
    </header>
  );
}
